import React from "react";
import PageBlockContextMenu from "organisms/page-blocks/page-block-list/page-block-context-menu";
import PageBlockToolbarWrapper from "molecules/page-block-content/page-block-toolbar-wrapper";
import ToggleButton from "atoms/forms/toggle-button";
import { t } from "utilities/localization-utils";

interface CodeReferenceBlockToolbarProps {
    isEnhancedContentDisplayed: boolean;
    onDone?: () => Promise<void>;
    onDelete: () => Promise<void>;
    onMoveUp: () => Promise<void>;
    onMoveDown: () => Promise<void>;
    onToggleEnhancedContentDisplay: () => Promise<void>;
}

const CSS_CLASS_NAME = "c-code-reference-block";

const CodeReferenceBlockToolbar: React.FC<CodeReferenceBlockToolbarProps> = ({
    onDone,
    onDelete,
    onMoveUp,
    onMoveDown,
    isEnhancedContentDisplayed,
    onToggleEnhancedContentDisplay,
}) => {
    return (
        <PageBlockToolbarWrapper onDone={onDone}>
            <div className={`${CSS_CLASS_NAME}__toolbar-content`}>
                <div className={`${CSS_CLASS_NAME}__toggle`}>
                    <label className={`${CSS_CLASS_NAME}__label`}>
                        {t("show-enhanced-content")}
                    </label>
                    <ToggleButton
                        checked={isEnhancedContentDisplayed}
                        label={t("show-enhanced-content")}
                        onChange={onToggleEnhancedContentDisplay}
                    />
                </div>
                <PageBlockContextMenu
                    inline
                    mobileOnly
                    onDelete={onDelete}
                    onMoveUp={onMoveUp}
                    onMoveDown={onMoveDown}
                />
            </div>
        </PageBlockToolbarWrapper>
    );
};

export default CodeReferenceBlockToolbar;
